import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Home.css";
import OurTech from "./OurTech";
import AllServices from "./AllServices";
import News from "./News";

const Home = () => {

  return (
    <div className="home-page">
      {/* Hero Section */}
      <div className="hero-section py-5">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0">
              <h1 className="display-4 fw-bold mb-4">
                Stronger, Faster & Affordable Intellectual Property Protection
                for Science
              </h1>
              <p className="lead mb-4">
                The Fyled platform leverages AI-driven bioinformatics to bridge
                the gap between scientific innovation and intellectual property
                by streamlining data analysis and guiding the IP process for
                both scientists and IP professionals.
              </p>
              {/* <div className="d-flex flex-wrap gap-2">
                <Button
                  variant="primary"
                  size="lg"
                  onClick={() => handleNavigate("/demo")}
                >
                  Try Demo
                </Button>
                <Button
                  variant="outline-primary"
                  size="lg"
                  onClick={() => handleNavigate("/signup")}
                >
                  Get Started
                </Button>
              </div> */}
            </Col>
            <Col lg={6}>
              {/* Main container with animation */}
              <div className="relative w-full h-full">
                {/* Lab scientists image with enhanced styling */}
                <div
                  className="absolute inset-0 z-10 "
                  style={{
                    position: "relative",
                    overflow: "hidden",
                    height: "420px",
                    width: "500px",
                    borderRadius: "16px",
                    boxShadow: "0 15px 30px rgba(0, 141, 231, 0.2)",
                    // background:"linear-gradient(135deg, #0B3166 0%, #33aeff 100%)",
                    border: "3px solid #2563eb",
                  }}
                >
                  <video
                    src={`/videos/laboratory.mp4`}
                    className="w-full h-full object-cover rounded-lg hero-main-image"
                    style={{
                      // borderRadius: "16px", // match parent
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      filter: "contrast(1.05) brightness(1.02)",
                      transition: "transform 0.8s ease, filter 0.5s ease",
                      // width: "--webkit", // Position video to show top portion and crop bottom
                    }}
                    autoPlay
                    muted
                    loop
                  />
                </div>

                {/* Overlay gradient for depth */}
                <div
                  className="absolute inset-0 z-20 image-overlay-gradient"
                  style={{
                    background:
                      "linear-gradient(145deg, rgba(0,141,231,0.15) 0%, rgba(13,22,54,0.35) 100%)",
                    borderRadius: "12px",
                    opacity: "0.6",
                  }}
                ></div>

                {/* Decorative element - animated corner accent */}
                {/* <div className="hero-corner-accent top-right"></div>
                <div className="hero-corner-accent bottom-left"></div> */}
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <hr color="#008DE7" />

      <OurTech />

      <AllServices />
      
      <News />

      {/* Features Section */}

      {/* Call to Action */}
      {/* <div className="cta-section py-5">
        <Container className="text-center">
          <h2 className="mb-4 cta-section-text">Ready to get started?</h2>
          <p className="lead mb-4">
            Join thousands of scientists and researchers who trust Fyled AI for
            their chemical structure analysis.
          </p>
          <Button
            variant="primary"
            size="lg"
            className="cta-section-text"
            onClick={() => handleNavigate("/signup")}
          >
            Sign Up
          </Button>
        </Container>
      </div> */}
    </div>
  );
};

export default Home;
